import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import ActionLink from "../../common/widgets/ActionLink.js";
import ActionButton from "../../common/widgets/ActionButton.js";
import BlogUtils from "./BlogUtils.js";
import Card from "react-bootstrap/Card";
import CategoryIcon from "@mui/icons-material/Category";
import useTranslationBlog from "../useTranslationBlog.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import "./BlogPostPreview.scss";
import useReferrer from "../../infra-no-ui/navigation/useReferrer.js";

export default function BlogPostPreview(props) {
  const { article } = props;
  const {redirectTo} = useReferrer();

  const { t, loading: tLoading } = useTranslationBlog();
  useShowLoader(tLoading, "BlogPostPreview");

  const onClickCategory = (category) => {
    redirectTo(BlogUtils.getBlogCategoryRoute(category));
  };


  const onClickTitle = (category, url) => {
    redirectTo(BlogUtils.getBlogPostRoute(category, url));
  };

  return (
    <div className="BlogPostPreview">
      <Row className="post-col-row">
        <Col className="post-col">
          <Card className="post-card">
            <Card.Img
              variant="top"
              src={
                article.fields.featuredImage
                  ? article.fields.featuredImage.fields.file.url
                  : ""
              }
              className="image-post"
            />
            <Card.Body className="post-body">
              <Row>
                <Col className="title-col">
                  <Card.Title>
                    <ActionLink
                      className="title-link"
                      onClick={() =>
                        onClickTitle(
                          article.fields.categoryEntity.fields.categoryUrl,
                          article.fields.url
                        )
                      }
                    >
                      {article.fields.title}
                    </ActionLink>
                  </Card.Title>
                </Col>
              </Row>
              <Row className="post-information">
                <Col>
                  <Row className="post-information-row">
                    <Col className="icon-group">
                      <Row>
                        <Col className="icon-col">
                          <CategoryIcon />
                        </Col>
                        <Col>
                          <ActionLink
                            onClick={() =>
                              onClickCategory(
                                article.fields.categoryEntity.fields.categoryUrl
                              )
                            }
                          >
                            {article.fields.categoryEntity.fields.categoryName}
                          </ActionLink>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col>{article.fields.resume}</Col>
              </Row>
              <Row>
                <Col className="action-col">
                  <ActionButton
                    onClick={() =>
                      onClickTitle(
                        article.fields.categoryEntity.fields.categoryUrl,
                        article.fields.url
                      )
                    }
                  >
                    {t("blog:blog_read")}
                  </ActionButton>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
